
export const ContentNames = {
    'SUMMARY' : 'summary',
    'AGENDA' : 'agenda',
    'DIAGNOSIS' : 'diagnosis',
    'DENTISTRY': 'dentistry',
    'PROFILE' : 'profile',
  };

export const GeneralContentNames = {
    'SEARCH' : 'search',
    'SUMMARY' : 'summary',
    'ADDRESSES' : 'addresses',
    'PROFILE' : 'profile',
    'EMERGENCY_CONTACTS': 'emergency_contacts',
    'PRIVACY' : 'privacy',
    'BILLING' : 'billing',
    'SETTINGS' : 'settings',    
  };

    